import {LoginModel} from "./auth.models";
import {Form, Formik, FormikHelpers} from "formik";
import FormField from "../../components/controls/FormField";
import Button from "../../components/controls/FlintButton";
import React from "react";
import * as Yup from 'yup';
import FlintLoadingWrapper from "../../components/page_components/common/loading/FlintLoadingWrapper";
import {useTranslation} from "react-i18next";

export default function AuthForm(props: authFormProps) {
    const {t} = useTranslation();
    return (
        <Formik
            initialValues={props.model}
            onSubmit={props.onSubmit}
            validationSchema={Yup.object({
                Username: Yup.string().required("Username is required"),
                Password: Yup.string().required("Password is required")
            })}>
            {formikProps => (
                <Form className={"row gy-0"}>
                    <div className="col-12">
                        <div className={"form-group"}>
                            <FormField fieldName={"Username"} label={t("LOGIN_UserNameOrEmail")}/>
                        </div>
                    </div>
                    <div className="col-12">
                        <FormField fieldName={"Password"} inputType={"password"} label={t("COMMON_Password")}/>
                    </div>
                    <div className="col-12">
                        <div className={"text-end"}>
                            <a href="https://flintlink.onelogin.com/" className="text-600 ml-auto">{t("LOGIN_ForgotPassword")}</a>
                        </div>
                    </div>
                    <div className="col-12 mt-1">
                        <div className={"text-center"}>
                            <Button disabled={formikProps.isSubmitting} className={"w-100"} type="submit">{t("LOGIN_SIGN_IN")}</Button>
                        </div>
                    </div>
                </Form>
            )}
        </Formik>
    )
}

interface authFormProps {
    model: LoginModel;

    onSubmit(values: LoginModel, actions: FormikHelpers<LoginModel>): void;
}